// extracted by mini-css-extract-plugin
module.exports = {"button1":"buttonNextLevel_button1__kzc3T","icon":"buttonNextLevel_icon__3823v","body":"buttonNextLevel_body__3e221","air":"buttonNextLevel_air__1etDp"};